import { useContext, useEffect } from "react";
import TitleContext from "../context/TitleContext";
import ViewSMSBotProbesComponent from "../components/smsBotProbes/ViewSMSBotProbes";

const SMSBotProbesPage = () => {
  const { setTitle } = useContext(TitleContext);

  useEffect(() => {
    setTitle("SMS Bots");
  }, [setTitle]);
  return (
    <>
      <ViewSMSBotProbesComponent />
    </>
  );
};
export default SMSBotProbesPage;
